// extracted by mini-css-extract-plugin
export default {"list":"Item_list__NyPhX","list__icon":"Item_list__icon__3fPV9","list__name":"Item_list__name__CJPy+"};